import { Box } from '@mui/material'

/** Up to two initials from a name, for a tile or an avatar. Nothing is fetched. */
export function initialsOf(name: string | undefined | null): string {
  const words = (name ?? '').split(/\s+/).filter(Boolean)
  return words
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
}

/**
 * A square tile holding a record's initials: the header mark on a dialog that
 * is about a company or a person. Decorative, so it is hidden from assistive
 * technology; the name is already the dialog title.
 */
export function Monogram({ name, size = 40 }: { name: string | undefined | null; size?: number }) {
  const text = initialsOf(name)
  if (!text) return null
  return (
    <Box
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        borderRadius: '8px',
        border: 1,
        borderColor: 'divider',
        backgroundColor: 'background.default',
        color: 'text.primary',
        display: 'grid',
        placeItems: 'center',
        fontSize: size >= 40 ? '0.875rem' : '0.6875rem',
        fontWeight: 600,
        letterSpacing: '0.01em',
        flexShrink: 0,
        userSelect: 'none',
      }}
    >
      {text}
    </Box>
  )
}

/** A round version for a person in a list. */
export function Avatar({ name, size = 32 }: { name: string | undefined | null; size?: number }) {
  const text = initialsOf(name)
  return (
    <Box
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: 1,
        borderColor: 'divider',
        backgroundColor: 'action.hover',
        color: 'text.primary',
        display: 'grid',
        placeItems: 'center',
        fontSize: '0.6875rem',
        fontWeight: 600,
        flexShrink: 0,
        userSelect: 'none',
      }}
    >
      {text}
    </Box>
  )
}
